import React from 'react'

const SalesTicketDailyShift = ({row}) => {
  return <div>{row?.salesTickets?.toLocaleString()}</div>;
}

export default SalesTicketDailyShift